import React, { Component } from "react";
import { withStyles } from "material-ui";
import Paper from "material-ui/Paper";
import classNames from "classnames";

const styles = theme => ({
  container: {
    flex: "1 1 0%",
    minWidth: 0,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.default,
    padding: "70px 10px 15px 10px"
  },

  paper: {
    width: "100%",
    maxWidth: "100%",
    height: "calc(100vh - 80px)",
    overflowX: "auto",
    overflowY: "auto",
    borderRadius: "0px",
    boxSizing: "border-box"
  },

  fullWidthContainer: {
    width: "100%",
    maxWidth: "100%"
  }
});

class MainContainer extends Component {
  render() {
    const { classes, children, shouldRenderMobileMenu } = this.props;

    const containerClass =
      shouldRenderMobileMenu === true
        ? classNames(classes.paper, classes.fullWidthContainer)
        : classes.paper;

    return (
      <main className={classes.container}>
        <Paper className={containerClass} elevation={4}>
          {children}
        </Paper>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainContainer);